<template>
  <div class="headerLogo">
    <img src="../../assets/index_header_logo.png" alt="青新学吧" class="logoImg" />
    <span class="logoTxt">教师个性化培训平台</span>
  </div>
</template>

<style spoed>
.headerLogo {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
  height: 36px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  margin-top: 14px;
  margin-right: 51px;
  float: left;
}

.logoImg {
  display: inline-block;
  width: 141px;
  height: 36px;
  margin-right: 17px;
}

.logoTxt {
  display: inline-block;
  color: #565656;
  font-size: 12px;
}
</style>